"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(props) {
        return _super.call(this, props) || this;
    }
    RadioButton.prototype.render = function () {
        var _a = this.props, id = _a.id, disabled = _a.disabled, value = _a.value, json_data = _a.json_data, group_name = _a.group_name, onChange = _a.onChange;
        var checked = value === json_data[group_name];
        return (React.createElement("input", { type: "radio", id: id, disabled: disabled, name: group_name, value: value, checked: checked, onChange: function (event) {
                onChange(group_name, value);
            } }));
    };
    return RadioButton;
}(react_1.Component));
exports.RadioButton = RadioButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9CdXR0b24uanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1JhZGlvQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQVcvQjtJQUFpQywrQkFBb0I7SUFDakQscUJBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBQ00sNEJBQU0sR0FBYjtRQUNVLElBQUEsZUFBbUUsRUFBbEUsVUFBRSxFQUFFLHNCQUFRLEVBQUUsZ0JBQUssRUFBRSx3QkFBUyxFQUFFLDBCQUFVLEVBQUUsc0JBQXNCLENBQUE7UUFDekUsSUFBTSxPQUFPLEdBQUcsS0FBSyxLQUFLLFNBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQTtRQUUvQyxPQUFPLENBQ0gsK0JBQ0ksSUFBSSxFQUFDLE9BQU8sRUFDWixFQUFFLEVBQUUsRUFBRSxFQUNOLFFBQVEsRUFBRSxRQUFRLEVBQ2xCLElBQUksRUFBRSxVQUFVLEVBQ2hCLEtBQUssRUFBRSxLQUFLLEVBQ1osT0FBTyxFQUFFLE9BQU8sRUFDaEIsUUFBUSxFQUFFLFVBQUMsS0FBSztnQkFDWixRQUFRLENBQUMsVUFBVSxFQUFFLEtBQUssQ0FBQyxDQUFBO1lBQy9CLENBQUMsR0FDSCxDQUNMLENBQUE7SUFDTCxDQUFDO0lBQ0wsa0JBQUM7QUFBRCxDQUFDLEFBdEJELENBQWlDLGlCQUFTLEdBc0J6QztBQXRCWSxrQ0FBVyJ9